import { render } from "./Distributions.vue?vue&type=template&id=e764a27a"
import script from "./Distributions.vue?vue&type=script&lang=js"
export * from "./Distributions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__